import React from 'react';
import './App.css'; 

const Footer = () => {
  return (
    
    <footer className="footer fade-in">
      <div className="copyright">
        &copy; {new Date().getFullYear()} HBA Housing Ltd <br></br>CompanyNo: 15717401 <br></br>All Rights Reserved.
      </div>

    </footer>
    
  );
};

export default Footer;
